<template>
  <section style="width: 100%">
    <v-layout row wrap align-center>
      <v-flex xs12 md6>
        <v-select outline v-model="currentHealthCard.physically_active" label="Está ativo atualmente?"
          :items="['Sim', 'Não']" append-icon="fal fa-angle-down"
        ></v-select>
      </v-flex>
      <v-flex xs12 md6>
        <v-text-field v-model="currentHealthCard.last_training_at" label="Está há quanto tempo sem treinar?"
          required outline></v-text-field>
      </v-flex>
      <!-- _________________ -->
      <v-flex xs12>
        <v-textarea v-model="currentHealthCard.routine_descrition" label="Descreva sua rotina diária:"
          rows="3" auto-grow required outline></v-textarea>
      </v-flex>
      <v-flex xs12>
        <v-textarea v-model="currentHealthCard.eating_summary" label="Descreva sua alimentação diária:"
          rows="3" auto-grow required outline></v-textarea>
      </v-flex>
      <!-- _________________ -->
      <v-flex xs12 md4>
        <v-text-field v-model="currentHealthCard.weekly_availability" label="Diponibilidade de treino semanal:"
          placeholder="Ex.: Segunda, quarta, quinta e sábado"
          required outline></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field v-model="currentHealthCard.daily_time" label="Tempo diário para treino"
          placeholder="Ex.: De 40min à 1h"
          required outline></v-text-field>
      </v-flex>
      <v-flex xs12 md5>
        <v-text-field v-model="currentHealthCard.extra_physical_activity" label="Faz alguma atividade extra na academia?"
          required outline></v-text-field>
      </v-flex>
      <!-- _________________ -->
      <v-flex xs12 md4>
        <v-text-field v-model="currentHealthCard.smoker" label="Faz uso de cigarro? Quantos?"
          required outline></v-text-field>
      </v-flex>
      <v-flex xs12 md4>
        <v-text-field v-model="currentHealthCard.consume_alcohol" label="Consome álcool? Quanto?"
          required outline></v-text-field>
      </v-flex>
      <!-- _________________ -->
      <v-flex xs12>
        <v-textarea v-model="currentHealthCard.past_training_description" label="Descreva seus últimos treinos:"
          rows="3" auto-grow outline required></v-textarea>
      </v-flex>
      <v-flex xs12 md6>
        <v-textarea v-model="currentHealthCard.pathological_conditions" label="Quais são suas limitações patológicas?"
          rows="3" auto-grow outline required></v-textarea>
      </v-flex>
      <v-flex xs12 md6>
        <v-textarea v-model="currentHealthCard.osteoarticular_conditions" label="Quais suas limitações osteomioarticulares?"
          rows="3" auto-grow outline required></v-textarea>
      </v-flex>
      <!-- _________________ -->
      <v-flex xs12>
        <v-text-field v-model="currentHealthCard.health_problems" label="Seu médico já lhe relatou quais problemas de saúde?"
          required outline></v-text-field>
      </v-flex>
      <!-- _________________ -->
      <v-flex xs12 md6>
        <v-textarea v-model="currentHealthCard.physical_objectives" label="Quais seus objetivos com esse programa?"
          rows="3" auto-grow outline required></v-textarea>
      </v-flex>
      <v-flex xs12 md6>
        <v-textarea v-model="currentHealthCard.general_observations" label="Observações gerais sobre você:"
          rows="3" auto-grow outline required></v-textarea>
      </v-flex>
    </v-layout>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click.stop="create()" round large depressed color="success" :loading="loadingRequest">
        <span v-if="currentHealthCard._id">Salvar AVALIAÇÃO</span>
        <span v-else>ENVIAR AVALIAÇÃO</span>
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </section>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'

export default {
  props: ['healthCard', 'user'],

  data: () => ({
    currentUser: {},
    currentHealthCard: {},
    loadingRequest: false
  }),

  methods: {
    create () {
      this.loadingRequest = true
      // eslint-disable-next-line
      let path = `${API.userHealthyCards}/users/${this.currentUser._id}`
      let $method

      if (this.currentHealthCard._id) {
        $method = axios.put
      } else {
        $method = axios.post
      }

      $method(path, this.currentHealthCard).then(response => {
        this.loadingRequest = false
        EventBus.$emit('loadUserEvaluations', false)
        EventBus.$emit('showNewHealthCard', false)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao salvar o questionário de saúde',
          color: 'error'
        })
        this.loadingRequest = false
      })
    }
  },

  mounted () {
    if (!this.user) {
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'))
    } else {
      this.currentUser = this.user
    }

    if (this.healthCard) {
      this.currentHealthCard = this.healthCard
    }
  }
}
</script>

<style scoped>
.v-input.v-text-field {
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/evaluations/UserHealthCardItem.vue